/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { useEffect, useState } from 'react';
import { configOptionsPWC, trees } from '../../config/forgerockConfig';
import { CallbackType, FRAuth, FRLoginFailure, FRLoginSuccess, FRStep, StepType } from '@forgerock/javascript-sdk';
import { isNil, set } from 'lodash';
const tree = trees.samlLogin;
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from '../../components/common/Translation/translationProvider';
import Loader from '../../components/common/Loader/Loader';
import CallbasedViewGenerator from '../../components/common/CallbasedViewGenerator/CallbasedViewGenerator';
import { MessageType } from '../../interfaces/baseInterface';
import { checkAndValidatePortalParam, clearBrowserData, getTree, handlePortalName } from '../../utils/FRCallBackUtil';

const saml = () => {
    const [step, setStep] = useState<FRStep | FRLoginFailure | FRLoginSuccess | null>(null);
    const navigate = useNavigate()
  const tree =getTree('samlLogin')
    const [goto, setGoto] = useState('');
    const [redirectUI, setRedirectUI] = useState('')
    const [messageType, setMessageType] = useState(MessageType.info);
    const [message, setMessage] = useState('');
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [isSubmitHidden,setIsSubmitHidden] = useState(true)

    const { t } = useTranslation();
    const params = new URLSearchParams(location.search);
    const portal = params.get('portal')?.toLowerCase() ?? '';

    checkAndValidatePortalParam();
    handlePortalName();


    useEffect(() => {
        (async function getStep() {
            const urlLocation = window.location.search
            let firstCause = decodeURIComponent(urlLocation.split('goto=')[1] ? urlLocation.split('goto=')[1] : '');
            const goto = firstCause.split('&authIndexType=service')[0]
             setGoto(goto)
            // const goto = new URLSearchParams(window.location.search).get('goto') || '';
            // setGoto(new URLSearchParams(window.location.search).get('goto') || '')
            const stepString = sessionStorage.getItem('step')
            //const code = sessionStorage.getItem('mfacode')
            //const state = sessionStorage.getItem('mfastate')
            let step;
            if (!!stepString) {
                step = JSON.parse(stepString).payload;
            }
            setRedirectUI(new URLSearchParams(window.location.search).get('redirectUi') || '')
            if (!!!step) {
                try {
                    const initialStep = await FRAuth.start({ tree, query: { portal,goto } });
                    if (initialStep && initialStep.type === StepType.Step) {
                        initialStep.callbacks.forEach((callback, i) => {
                            const type = callback.getType()
                            if (type === CallbackType.RedirectCallback) {
                                if (callback.getOutputValue('trackingCookie')) {
                                    // save current step information for later resumption of tree.
                                    sessionStorage.setItem('authIndexValue', tree);
                                    sessionStorage.setItem('step', JSON.stringify(initialStep));
                                    sessionStorage.setItem('realm', 'PWC');
                                    localStorage.setItem(FRAuth.previousStepKey, JSON.stringify(initialStep))
                                }
                                const redirectUrl = callback.getOutputValue('redirectUrl') as string;
                                setRedirectUI(new URLSearchParams(window.location.search).get('redirectUi') || '')
                                if (callback.getOutputValue('redirectMethod') === 'POST') {
                                    const redirectData = callback.getOutputValue('redirectData') as string;
                                    const form = document.createElement('form');
                                    form.method = 'post';
                                    form.action = redirectUrl;

                                    Object.entries(redirectData as string).forEach(([key, value]) => {
                                        const hiddenField = document.createElement('input');
                                        hiddenField.type = 'hidden';
                                        hiddenField.name = key;
                                        hiddenField.value = value;

                                        form.appendChild(hiddenField);
                                    });

                                    document.body.appendChild(form);
                                    form.submit();
                                } else {
                                    window.location.href = redirectUrl;
                                }
                            }else{
                                setStep(initialStep);
                            }
                        })
                    }else if(initialStep && initialStep.type === StepType.LoginSuccess){ 

                        setStep(initialStep);
                    }
                } catch (err) {
                    console.error(`Error: request for initial step; ${err}`);
                }
            } else {
                try {
                    const nextStep = await FRAuth.resume(window.location.href);
                    setStep(nextStep);
                } catch (err) {
                    console.error(`Error: request for initial step; ${err}`);
                    sessionStorage.removeItem('authIndexValue');
                    sessionStorage.removeItem('step');
                    sessionStorage.removeItem('realm');
                }

            }
        })();


    }, []);


    useEffect(() => {
         if (step && step.type === StepType.Step) {

            switch (step.getStage()) {

                case "getINNumber": 
                    setIsSubmitHidden(false);
                    break;
                case "noAccountFound":    
                    sessionStorage.removeItem('authIndexValue');
                    sessionStorage.removeItem('step');
                    sessionStorage.removeItem('realm');         
            }
        }
        
    },[step])

    function getSamlView() {

        let uiElement = <Loader></Loader>
        if (step && step.type === StepType.Step) {

            uiElement=<CallbasedViewGenerator key={step.getStage()} step={step as FRStep} setStep={setStep}
                        tree={tree} messageType={messageType} setMessageType={setMessageType}
                        message={message} setMessage={setMessage} isAlertOpen={isAlertOpen} setIsAlertOpen={setIsAlertOpen} isSubmitHidden={isSubmitHidden}></CallbasedViewGenerator>

        }
        else if (step && step.type === StepType.LoginSuccess) {
              if (goto && goto != null && goto != '' && goto != undefined) {
            fetch(configOptionsPWC.host + "/login/json/realms/root/realms/" + configOptionsPWC.realmPath + "/users?_action=validateGoto", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "Accept-API-Version": "protocol=2.1,resource=3.0",
              },
              body: JSON.stringify({ goto: goto }),
            })
              .then((response) =>
                response.json().then((data) =>{
                   // clearBrowserData()
                  window.location.replace(data.successURL)
                })).catch(()=>{
                   window.location.replace(portal === 'customer' ? import.meta.env.VITE_PWC_CUSTOMER_URL : import.meta.env.VITE_PWC_SUPPLIER_URL);
                })
            
            sessionStorage.removeItem('mfacode');
            sessionStorage.removeItem('mfastate');
            sessionStorage.removeItem('step');
          }
          else {
            if (redirectUI && redirectUI != null && redirectUI != '' && redirectUI != undefined) {
                navigate(redirectUI)
            } else {
                 window.location.replace(portal === 'customer' ? import.meta.env.VITE_PWC_CUSTOMER_URL : import.meta.env.VITE_PWC_SUPPLIER_URL);
            }
        }
        } else if (step && step.type === StepType.LoginFailure) {
            sessionStorage.removeItem('authIndexValue');
            sessionStorage.removeItem('step');
            sessionStorage.removeItem('realm');
        }
        return uiElement;
    }

    return (
        <>
            {getSamlView()}
        </>
    );


};

export default saml;
